import './sessions_view.js.coffee'
Monitoring.Views.SocialContents ||= {}

# This is to emulate the sessions and show a tab with name. But it is not intended to use it to handle multiple sessions
class Monitoring.Views.SocialContents.ReviewQueueSessionsView extends Monitoring.Views.SocialContents.SessionsView
  template: JST['backbone/templates/monitoring/sessions/review_queue_sessions']
  el: 'body'

  events :
    'click #new_session': '_addNewTab'
    'mouseleave li.session' : 'onMouseLeaveSession'

  initialize: (dashboard) ->
    @dashboard = dashboard
    @tabs = []

  render: (options = {}) ->
    $('#main-header #tabs').html(@template())
    sessionTab = new Monitoring.Views.SocialContents.ReviewQueueSessionTabView(dashboard: @dashboard)
    sessionTab._renameTooltip(I18n.t('monitoring.dashboard.session.tab.placeholder'))

    @tabs.push(sessionTab)
    $('#main-header #tabs').append(sessionTab.render().el)
    $('#content').append(sessionTab.dashboard.el)

    sessionTab.dashboard.bind('afterFirstSearch', (info) =>
      sessionTab.updateCount(info.sizeInformation)
      sessionTab.rename(info.name)
    )
    sessionTab.dashboard.render()
    sessionTab.dashboard.newSearch()
    @
